/** @jsx jsx */

import reviewToolReviewsBubble from 'assets/reviewToolReviewsBubble.svg';
import { css, jsx } from '@emotion/core';
import pubSub from 'services/pubSub';

export const ReviewToolButton = ({ size }) => {
  return (
    <button
      className="fader_-2s"
      css={css({
        all: 'unset',
        position: 'absolute',
        left: 25,
        bottom: 10,
        width: size,
        height: size,
        background: `rgb(255, 94, 62) url('${reviewToolReviewsBubble}') no-repeat`,
        backgroundSize: '50%',
        backgroundPosition: 'center',
        borderRadius: '50%',
        cursor: 'pointer',
        pointerEvents: 'auto',
        transition: 'all 0.3s',
        boxShadow: `0 3px 10px rgba(0, 0, 0, 0)`,
        ':hover': {
          boxShadow: `0 3px 10px rgba(0, 0, 0, 0.25)`,
        },
      })}
      onClick={() => {
        pubSub.publish('TOGGLE_REVIEW_TOOL', {});
      }}
    />
  );
};
